export default "/images/vendor/flag-icons/flags/4x3/yt.svg?433b076a0fbb984af9f2bc023eea5232";